import {PostDeliveryNoteRequest} from '@dms/api/warehouse';
import {VatRateOption} from '@dms/shared';

import {precisionCalculation} from 'shared/web';

import {
  DeliveryNoteDocumentPreviewFormDefinition,
  DeliveryNoteItem,
} from '../types/DeliveryNoteDocumentPreviewFormDefinition';

export function mapFormValuesToDeliveryNoteRequest(
  formValues: DeliveryNoteDocumentPreviewFormDefinition,
  vatRates: VatRateOption[]
): PostDeliveryNoteRequest {
  return {
    supplierId: formValues.basicInformation.supplier,
    warehouseId: formValues.basicInformation.warehouse,
    deliveryNoteNumber: formValues.basicInformation.deliveryNoteNumber,
    invoiceNumber: formValues.basicInformation.invoiceNumber,
    authorizationProfileId: formValues.basicInformation.authorizationProfile,
    paymentType: formValues.basicInformation.paymentType,
    currency: formValues.basicInformation.currency,
    externalRef: {
      extractionId: formValues.extractionId,
    },
    item: formValues.listOfItems
      .filter((item: DeliveryNoteItem) => item.isActive)
      .map((item: DeliveryNoteItem) => ({
        catalogNumber: item.number ?? '',
        name: item.name ?? '',
        vatType: item.vat ?? '',
        vatRate: Number(vatRates.find((vat) => vat.value === item.vat)?.rate) || 0,
        purchasePrice: precisionCalculation.round(item.unitPrice ?? 0, 2),
        stockValue: precisionCalculation.round(item.totalPrice ?? 0, 2),
        quantity: item.quantity ?? 0,
        manufacturerId: item.manufacturer ?? '',
        handlingUnit: item.unit ?? '',
      })),
  };
}
